import { useIntl } from 'react-intl';
import { generatePath } from 'react-router-dom';

import ManageSyncPair from '~/components/Admin/IntegrationPage/ManageSyncPair/ManageSyncPair';
import ProcurementIntegrations from '~/components/Admin/IntegrationPage/ProcurementIntegrations/ProcurementIntegrations';
import { PageLayout } from '~/eds/src/modules/PageLayout/PageLayout';
import { RoutePathType } from '~/routing/enums';
import { useRouting } from '~/routing/useRouting';

const Page = () => {
  const intl = useIntl();
  const { params } = useRouting();
  const { clientId } = params;
  const nav = {
    actions: [
      {
        text: intl.formatMessage({
          id: 'IntegrationsDeprecated.navTitle',
          defaultMessage: 'Integrations',
          description: 'Navigation title for integrations page',
        }),
        pathname: generatePath(RoutePathType.AdminConsoleClientIntegrations, {
          clientId: clientId as string,
        }),
      },
      {
        text: intl.formatMessage({
          id: 'Procurement.pageTitle',
          defaultMessage: 'Procurement',
          description: 'Procurement page title',
        }),
        pathname: generatePath(RoutePathType.AdminConsoleClientProcurement, {
          clientId: clientId as string,
        }),
      },
    ],
  };

  return (
    <>
      <PageLayout
        title={intl.formatMessage({
          id: 'Procurement.pageTitle',
          defaultMessage: 'Procurement',
          description: 'Procurement page title',
        })}
        nav={nav}
      >
        <ProcurementIntegrations />
      </PageLayout>
      <ManageSyncPair />
    </>
  );
};

export default Page;
